// extracted by mini-css-extract-plugin
export default {"container":"InputCheckbox_container__U-9kp","radio":"InputCheckbox_radio__pQznR","label":"InputCheckbox_label__+qc3d","radioBox":"InputCheckbox_radioBox__qKrny"};